import {_} from 'lodash';
import {
    IMessage,
    IMessageLog,
    IRouteDefinitionParams,
    ISearchParams,
    ITableColumn,
    TBaseOrObservableType,
    TRouteId
} from '../../index';
import {tpl, viewModel as SearchViewModel} from "../search/search";
import {getAnyValue} from "../../util/misc";
import {getSearchMessageLogParams} from "../../util/request";
import {getHash} from "../../constants/RouteDefinitions";
import {hasher} from 'hasher';

export const template = tpl;

interface IParams extends IRouteDefinitionParams {
    messageflow: TBaseOrObservableType<IMessage>
}

export class viewModel extends SearchViewModel<IMessage> {
    private isTask: boolean

    protected readonly TABLE: ITableColumn<IMessageLog>[]
    private messageflow: IMessage;

    constructor(params: IParams) {
        super(params);
        this.messageflow = getAnyValue(params.messageflow)
        this.isTask = [6, 7].includes(this.messageflow.messagetypeid);
        this.TABLE = [
            {key: 'Id'},
            {key: 'Sent', label: 'time'},
            {key: 'Recipient', label: this.isTask ? 'Formdata' : 'Recipient'},
            {key: 'TargetObjectId', label: '((Object)) ((id|ac))'},
            {key: 'targetname', label: this.isTask ? 'Name' : 'User'},
            {key: 'Result', label: this.isTask ? 'form id' : 'result', getContent: o => o.Result},
        ]
        if (!this.TABLE.map(o => o.key).includes(this.sortcol())) {
            this.sortcol('Id')
            this.asc(false)
        }
    }

    protected override getParams(): ISearchParams {
        const params = getSearchMessageLogParams({
            messageid: this.messageflow.id,
        })
        return _.defaultsDeep(super.getParams(), params)
    }

    protected override canRowClick(item: IMessageLog): boolean {
        return !!item.targetobjectid
    }

    protected override onRowClick(item: IMessageLog, e: JQuery.Event) {
        const routeId: TRouteId = this.isTask
            ? 'formdatadetails'
            : 'userdetails'
        hasher.setHash(getHash(routeId, {id: item.targetobjectid}, false));
    }

}
